/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-05 17:07:37
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-02-18 16:47:33
 * @Description: file content
 */
export const SET_INFO = "SET_INFO";
export const SET_ADDLIST = "SET_ADDLIST";
export const SET_CHANNEL = "SET_CHANNEL";
export const SET_ISINMINIPROGRAM = "SET_ISINMINIPROGRAM";
export const SET_ISLOADING = "SET_ISLOADING";
export const SET_ISSHOWGUIDE = "SET_ISSHOWGUIDE";
export const SET_RECEIVESPREADINFO = "SET_RECEIVESPREADINFO";
export const SET_SHARESPREADINFO = "SET_SHARESPREADINFO";
export const SET_PAGEINFO = "SET_PAGEINFO";
export const SET_CARDINFO = "SET_CARDINFO";
export const SET_USERINFO = "SET_USERINFO";
export const SET_HDKUSERINFO = "SET_HDKUSERINFO";
export const SET_SOURCEGZHINFO = "SET_SOURCEGZHINFO";
export const SET_ISSHOWMYCARD = "SET_ISSHOWMYCARD";
export const SET_RSCARDINFO = "SET_RSCARDINFO";